import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { useRef, useEffect, useState } from "react";
import oneLicenseImg from "../../public/lovable-uploads/One-license.png";
import bg from "../../public/lovable-uploads/0b3c3dab-7f08-4fa2-9306-06615336a55a.png";

export default function CallToAction({ invertColor = false }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
      {/*<div
        style={{
          height: "350px",
          marginBottom: "30px",
          backgroundImage: "url(" + bg + ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0,0,0,.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <div>
            <img
              src={oneLicenseImg}
              style={{ width: "300px", display: "block", margin: "auto", marginBottom: "30px" }}
            />
            <p style={{ width: "80%", display: "block", margin: "auto", textAlign: "center" }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since
            </p>
          </div>
        </div>
      </div>*/}
      <section
        ref={sectionRef}
        className={
          " py-16 section-transition relative overflow-hidden" +
          (invertColor ? "" : "section-red")
        }
      >
        {/* Light blob effects */}
        <div className="absolute inset-0 z-0">
          <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] bg-white/10 rounded-full filter blur-[80px]"></div>
          <div className="absolute bottom-1/3 left-1/3 w-[250px] h-[250px] bg-yellow-500/10 rounded-full filter blur-[100px]"></div>
        </div>

        {/* Noise texture */}
        <div className="noise-overlay"></div>

        <div className="editorial-container relative z-10">
          <div
            className={`max-w-4xl mx-auto text-center transition-all duration-1000 transform ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-20"
            }`}
          >
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6 drop-shadow-md">
              Join Music Nation
            </h2>
            <p className="font-sans text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Whether you create music or use it in your business, Music Nation
              ensures your rights and obligations are properly managed in
              compliance with UAE law.
            </p>
            <div className="flex flex-col md:flex-row justify-center gap-4">
              <Link
                to="/creators"
                className="transform transition-all duration-500 hover:scale-105"
              >
                <Button
                  className="bg-white text-musicRed hover:bg-white/90 hover:shadow-lg shadow-md transition-all duration-500 w-full md:w-auto border border-white/20"
                  size="lg"
                >
                  For Creators / Rights Holders
                </Button>
              </Link>
              <Link
                to="/businesses"
                className="transform transition-all duration-500 hover:scale-105"
              >
                <Button
                  className="bg-black text-white hover:bg-black/90 hover:shadow-lg shadow-md transition-all duration-500 w-full md:w-auto border border-white/10"
                  size="lg"
                >
                  For Businesses
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
